import { Button, Tooltip } from 'antd';
import { Link } from 'react-router-dom';
import IconColors from '../../enums/IconColors';

export default function IconButton({
  icon,
  title = null,
  className = '',
  bordered = false,
  color = undefined,
  linkTo = undefined,
  ...props
}) {
  const InnerButton = (
    <Button
      htmlType="button"
      {...props}
      type="text"
      icon={
        linkTo ? (
          <Link
            to={linkTo}
            {...(color
              ? {
                  style: { color: IconColors[color] },
                }
              : {})}
          >
            {icon}
          </Link>
        ) : (
          icon
        )
      }
      className={`${bordered ? 'icon-button-reset-bordered' : 'icon-button-reset'} ${className}`}
      {...(color
        ? {
            style: {
              color: IconColors[color],
              ...(bordered ? { borderColor: IconColors[color] } : {}),
            },
          }
        : {})}
    />
  );

  if (title) return <Tooltip title={title}>{InnerButton}</Tooltip>;
  return InnerButton;
}
